module.exports = __webpack_public_path__ + "static/img/4911_phase_function_Paper_PointsHejduk_Prediction.e199fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4911_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 6Qlk
// module chunks = 0